/**
 * Format container size for display
 * Converts "10Y" -> "10-yard", "20Y" -> "20-yard", etc.
 */
export function formatContainerSize(size: string): string {
  // Handle formats like "10Y", "20Y", "30Y", "40Y"
  const match = size.match(/^(\d+)Y$/i);
  if (match) {
    return `${match[1]}-yard`;
  }

  // Handle formats like "10 Yard", "20 Yard"
  const spaceMatch = size.match(/^(\d+)\s*yard$/i);
  if (spaceMatch) {
    return `${spaceMatch[1]}-yard`;
  }

  // Return as-is if already in correct format or unknown format
  return size;
}

/**
 * Parse container size to get numeric value
 * "10-yard" -> 10, "20Y" -> 20, etc.
 */
export function parseContainerSize(size: string): number {
  const match = size.match(/^(\d+)/);
  return match && match[1] ? parseInt(match[1], 10) : 0;
}
